import React, { useEffect, useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import { Collapse, Nav, UncontrolledCollapse } from "reactstrap";
import PerfectScrollbar from "perfect-scrollbar";
import logoImg from '../../assets/img/inspectalyLogoOnDark.png'
import { checkPermission, USER_PERMISSIONS } from "../../constants";

var ps;

function Sidebar(props) {
	const location = useLocation();
	const sidebar = React.useRef();
	const [routes, setRoutes] = useState([...props.routes])
	const [routesPermissions, setRoutesPermissions] = useState({
		'/lease': false,
		'/template': false,
		'/user': false
		//TODO: add permissions for reports
	});

	useEffect(() => {
		let lease = checkPermission(USER_PERMISSIONS.MANAGE_RENTER_CONNECTION);
		let template = checkPermission(USER_PERMISSIONS.MANAGE_TEMPLATES);
		let user = checkPermission(USER_PERMISSIONS.MANAGE_USERS);

		console.log('routes-permissions', {lease, template, user})
		setRoutesPermissions({
			'/lease': lease,
			'/template': template,
			'/user': user,
		})
	}, [])

	// verifies if routeName is the one active (in browser input)
	const activeRoute = (routeName) => {
		return location.pathname.indexOf(routeName) > -1 ? "active" : "";
	};
	React.useEffect(() => {
		if (navigator.platform.indexOf("Win") > -1) {
			ps = new PerfectScrollbar(sidebar.current, {
				suppressScrollX: true,
				suppressScrollY: false,
			});
		}
		return function cleanup() {
			if (navigator.platform.indexOf("Win") > -1) {
				ps.destroy();
			}
		};
	});
	return (
		<div
			className="sidebar"
			// data-color='rgba(100,100,100,1.0)'
			data-active-color='warning'
		// style={{ backgroundColor: 'rgba(100,100,100,1.0) !important' }}
		>
			<div className="logo">
				<a
					href="/"
					className="simple-text logo-mini"
				>

				</a>
				<a
					href="/dashboard"
					className="simple-text logo-normal"
				>
					Inspectaly
				</a>
			</div>
			<div className="sidebar-wrapper" ref={sidebar}>
				<Nav>
					{routes.filter(r => r.show).map((prop, key) => {
						// console.log('aaa', routes)
						if (Object.keys(routesPermissions).includes(prop.path) && routesPermissions[prop.path] == false) {
							return null;
						}

						return (
							<li
								className={
									activeRoute(prop.path) + (prop.pro ? " active-pro" : "")
								}
								style={{
									backgroundColor: '#2E6A54',
									marginLeft: '-10px',
									marginBottom: '-2px',
									color: 'white',
									fontWeight: 'bold'
								}}
								key={key}
							>
								<NavLink to={prop.path}
									//  className="nav-NavLink"
									style={{ padding: '8px' }}
									id={`sidebar_toggle_${key}`}
								>
									<i className={prop.icon} />
									<p>{prop.name}</p>
								</NavLink>
								{(prop.hasOwnProperty('sub_routes') && prop.sub_routes.length > 0) && (
								<UncontrolledCollapse toggler={`sidebar_toggle_${key}`}>
									<Nav style={{ backgroundColor: '#035e9b' }}>
										{prop.sub_routes.filter(r => r.show).map((sub_route, sub_key) => {
											return (
												<li
													className={
														activeRoute(sub_route.path) + (sub_route.pro ? " active-pro" : "")
													}
													key={`${key}_${sub_key}`}
												>
													<NavLink
														to={sub_route.path}
														className="nav-link"
														style={{ paddingLeft: '15px' }}
													>
														{sub_route.name}
													</NavLink>
												</li>
											)
										})}
									</Nav>
								</UncontrolledCollapse>
								)}
							</li>
						);
						
					})}
				</Nav>

				<div
					className="sidebar-logo"
					style={{
						position: 'absolute',
						bottom: '10px',
						left: '10px',
					}}
				>
					<img src={logoImg} alt="Inspectaly" style={{ width: '150px', height: 'auto' }} />
				</div>

			</div>
		</div>
	);
}

export default Sidebar;
